import { IAuditEvent } from 'types/api';

const SCIM_ACTION = 'SCIMEvent';
const FAILED_ACTIONS = ['LoginFailed', 'LoginStartedFailed'];

// A failed SCIM request is audited under the same info-level action as a successful one, so its
// error message is the only sign of the failure.
export const isAuditEventFailed = (event: IAuditEvent): boolean =>
	event.level === 'error' ||
	FAILED_ACTIONS.includes(event.action) ||
	!!event.errorMessage;

export const getAuditEventLabel = (event: IAuditEvent): string =>
	event.action === SCIM_ACTION
		? intl.tr('audit.event.scimAction', { scimAction: event.scimAction || '' })
		: intl.tr('audit.event.action', { action: event.action });

export const getAuditEventUser = (event: IAuditEvent): string | undefined =>
	event.loginIds?.[0] || event.userId;

// JSON is re-indented for reading; anything else (the SAML XML) is shown as recorded.
export const formatAuditDetail = (
	value: string
): { text: string; language: 'json' | 'xml' } => {
	try {
		return {
			text: JSON.stringify(JSON.parse(value), null, 2),
			language: 'json'
		};
	} catch {
		return { text: value, language: 'xml' };
	}
};
